export default "__VITE_ASSET__CJUWFhrp__";